// Cuanto tiempo se muestra una notificacion antes de cerrarse sola: lo que toma leerla.
// 4 s minimo ("Bienvenido Juan") + ~60 ms por letra, hasta 10 s para mensajes largos.
export function tiempoLectura(...textos) {
    const letras = textos.map((t) => String(t ?? "")).join(" ").trim().length
    return Math.min(10000, Math.max(4000, 3000 + letras * 60))
}
